<div #assetReorderLine class="assetReorderLine"></div>

<section class="fleetAssetsPage" #fleetAssets>
  @for (asset of ppAssets; track trackByFunction(index, asset); let index = $index) {
    <pp-asset-card
      [ppAsset]="asset"
      [ppIndex]="index"
    ></pp-asset-card>
  }
</section>

@if (ppAssets?.length) {
  <pp-asset-card-footer
    [ppAssetCount]="ppAssets.length"
  ></pp-asset-card-footer>
}
